<div class="signupForm" *ngIf="signupDone">
    <div class="alert alert-success">
        Din bruger er blevet oprettet! Der er blevet sendt en bekræftelses-mail til din email-adresse. Følg linket i den for at verificere din bruger.
    </div>
</div>
<div  class="signupForm" *ngIf="!signupDone">
    <form [formGroup]="signupFormGroup">
        <h2 class="text-center">Opret bruger</h2>
        <div *ngIf="wrongInput" class="alert alert-danger">
            {{wrongInputReason}}
        </div>
        <div class="form-group">
            <input class="form-control input-lg" placeholder="Brugernavn" formControlName="username">
        </div>
        <div class="form-group">
            <input class="form-control input-lg" type="password" placeholder="Kodeord" formControlName="password">
        </div>
        <div class="form-group">
            <input class="form-control input-lg" type="password" placeholder="...bekræft kodeord" formControlName="confirmPassword">
        </div>
        <div class="form-group">
            <input class="form-control input-lg" placeholder="Navn" formControlName="name">
        </div>
        <div class="form-group">
            <input class="form-control input-lg" placeholder="Email" formControlName="email">
        </div>  
        <div class="form-group">
            <button type="submit" class="btn btn-primary btn-lg btn-block"  (click)="onSubmit()">Opret</button>
        </div>
    </form>
</div>